module.exports = __webpack_public_path__ + "static/dyes_cash_reward_img-cbb657ae8021a1fe8cb923c60825bf62.png";